/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Keen_Fox_DashInputs */

const en_warm_keen_fox_dash = /** @type {(inputs: Warm_Keen_Fox_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PowerPoint export completed`)
};

const de_warm_keen_fox_dash = /** @type {(inputs: Warm_Keen_Fox_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PowerPoint-Export abgeschlossen`)
};

/**
* | output |
* | --- |
* | "PowerPoint export completed" |
*
* @param {Warm_Keen_Fox_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_keen_fox_dash = /** @type {((inputs?: Warm_Keen_Fox_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Keen_Fox_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_keen_fox_dash(inputs)
	return de_warm_keen_fox_dash(inputs)
});